import EditDateOverlay from '$components/EditDateOverlay/EditDateOverlay.vue';

import { formatDateForUi } from '$utils/dateFormat';
import getAssetPath from '$utils/getAssetPath';

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	components: {
		EditDateOverlay,
	},

	mounted() {
		this.applyValue(this.context.model ?? this.context.value);
	},

	data() {
		return {
			selectedDate: null,
		};
	},

	computed: {
		uiDate() {
			return formatDateForUi(this.selectedDate);
		},
		date: {
			get() {
				return this.selectedDate ? this.selectedDate : new Date()
			},
			set(val) {
				this.selectedDate = val;
				this.context.model = val;
			}
		}
	},

	watch: {
		'context.model': {
			immediate: true,
			handler(val) {
				this.applyValue(val);
			},
		},
	},

	methods: {
		formatDateForUi,
		getAssetPath,

		applyValue(val) {
			if (val == null || val === '') return;
			this.selectedDate = val;
		},

		onDateApply(date) {
			if (!date) return;
			this.selectedDate = date;
			// Use Formulate's input handler to properly register the value change
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input(date);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input(date);
			}
		},

		onDateClick() {
			this.$refs.editDateOverlay.show();
		},
	},
};
